import type { GasPriceInfo, GasPrices } from 'types/api/stats';

export type RawGasPrice = GasPriceInfo | number | null | undefined;
export type RawGasPrices = {
  slow?: RawGasPrice;
  average?: RawGasPrice;
  fast?: RawGasPrice;
} | null | undefined;

export function normalizeGasPriceInfo(value: RawGasPrice): GasPriceInfo | null {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value === 'number') {
    return {
      price: value,
      fiat_price: null,
      time: null,
      base_fee: null,
      priority_fee: null,
    };
  }

  return value;
}

export function normalizeGasPrices(prices: RawGasPrices): GasPrices | null {
  if (!prices) {
    return null;
  }

  return {
    slow: normalizeGasPriceInfo(prices.slow),
    average: normalizeGasPriceInfo(prices.average),
    fast: normalizeGasPriceInfo(prices.fast),
  };
}

export function hasGasPriceValue(info: GasPriceInfo | null): boolean {
  return Boolean(info?.fiat_price || info?.price);
}
